import React, { Component } from 'react'
import { API_URL } from '../constants'
import { getAccessToken, getCookie } from '../helpers/cookieHelper'
const axios = require('axios')
export default class RunfreshDataPage extends Component {
  constructor(props) {
    super(props)
    this.state = { data: '', isLoading: false }
  }
  componentDidMount() {
    this.getData()
  }
  getData = async () => {

    let url = new URL(window.location.href);
    const clientId = url.searchParams.get('clientId');
    let access_token = getCookie("access_token");
    let token_type = getCookie("token_type");
    let axiosConfig = {
      headers: {
        authorization: token_type + ' ' + access_token,
        'Content-Type': 'application/json',
      },
    }
    try {


      if (access_token != null) {
        this.setState({
          isLoading: true,
        })
        var response = await axios.post(API_URL + `api/runfreshdata`, { clientId }, axiosConfig)

        if (response.status === 200) {
          let dataObject = response.data.object

          this.setState({
            data: dataObject,
            isLoading: false
          })
        }
      } else {
        const resp = await getAccessToken()
        if (resp) {
          this.getData()
        }
      }
    }
    catch (e) {
      this.setState({
        isLoading: false
      })
    }
  }
  render() {
    var { data, isLoading } = this.state
    return (
      <div style={{ padding: 10 }}>
        <div
          className="loadingmodel"
          style={{ display: isLoading ? 'block' : 'none' }}
        ></div>
        {Object.keys(data).map(function (key) {
          return (
            <div>
              <h3>{key}</h3>
              <ul>
                {data[key].map(function (k) {
                  return <li>{k}</li>
                })}
              </ul>
            </div>
          )
        })}
      </div>
    )
  }
}
